"use strict";

exports.__esModule = true;
exports.calculatePreferencesViewForAppointment = exports.PreferenceType = exports.DisplayTarget = void 0;
var _bookingsCalendarCatalogViewerMapper = require("@wix/bookings-calendar-catalog-viewer-mapper");
var _serviceOptionsAndVariants = require("../../domain/serviceOptionsAndVariants/serviceOptionsAndVariants");
let PreferenceType = exports.PreferenceType = /*#__PURE__*/function (PreferenceType) {
  PreferenceType["STAFF_MEMBER"] = "STAFF_MEMBER";
  PreferenceType["DYNAMIC_PRICE"] = "DYNAMIC_PRICE";
  PreferenceType["ADD_ONS"] = "ADD_ONS";
  PreferenceType["LOCATION"] = "LOCATION";
  return PreferenceType;
}({});
let DisplayTarget = exports.DisplayTarget = /*#__PURE__*/function (DisplayTarget) {
  DisplayTarget["PREFERENCES_MODAL"] = "PREFERENCES_MODAL";
  DisplayTarget["CALENDAR"] = "CALENDAR";
  DisplayTarget["NONE"] = "NONE";
  return DisplayTarget;
}({});
const calculatePreferencesViewForAppointment = ({
  service,
  bookingsSettings,
  experiments,
  serviceOptionsAndVariants
}) => {
  const staffMemberDisplay = calculateStaffMemberDisplay(service, bookingsSettings, serviceOptionsAndVariants);
  const locationDisplay = calculateLocationDisplay(service, bookingsSettings);
  const addOnsDisplay = calculateAddOnsDisplay(service, experiments);
  const dynamicPriceDisplay = calculateDynamicPriceDisplay(addOnsDisplay, bookingsSettings, serviceOptionsAndVariants);
  return {
    [PreferenceType.STAFF_MEMBER]: staffMemberDisplay,
    [PreferenceType.LOCATION]: locationDisplay,
    [PreferenceType.DYNAMIC_PRICE]: dynamicPriceDisplay,
    [PreferenceType.ADD_ONS]: addOnsDisplay
  };
};
exports.calculatePreferencesViewForAppointment = calculatePreferencesViewForAppointment;
const calculateStaffMemberDisplay = (service, bookingsSettings, serviceOptionsAndVariants) => {
  if (!(0, _bookingsCalendarCatalogViewerMapper.isServiceWithMultiStaff)(service) || (0, _bookingsCalendarCatalogViewerMapper.isCustomerCannotChooseStaff)(bookingsSettings) && !(0, _serviceOptionsAndVariants.isStaffVariant)(serviceOptionsAndVariants)) {
    return DisplayTarget.NONE;
  }
  if ((0, _bookingsCalendarCatalogViewerMapper.isMultiServiceAppointment)(bookingsSettings) || (0, _bookingsCalendarCatalogViewerMapper.isStaffSelectionBeforeSlot)(bookingsSettings)) {
    return DisplayTarget.PREFERENCES_MODAL;
  }
  return DisplayTarget.CALENDAR;
};
const calculateLocationDisplay = (service, bookingsSettings) => {
  if (!(0, _bookingsCalendarCatalogViewerMapper.isServiceWithMultiBusinessLocations)(service)) {
    return DisplayTarget.NONE;
  }
  if ((0, _bookingsCalendarCatalogViewerMapper.isMultiServiceAppointment)(bookingsSettings) || (0, _bookingsCalendarCatalogViewerMapper.isLocationSelectionBeforeSlot)(bookingsSettings)) {
    return DisplayTarget.PREFERENCES_MODAL;
  }
  return DisplayTarget.CALENDAR;
};
const calculateDynamicPriceDisplay = (addOnsDisplay, bookingsSettings, serviceOptionsAndVariants) => {
  if ((0, _serviceOptionsAndVariants.isDurationVariant)(serviceOptionsAndVariants)) {
    return DisplayTarget.PREFERENCES_MODAL;
  }
  if ((0, _serviceOptionsAndVariants.isCustomVariant)(serviceOptionsAndVariants)) {
    if ((0, _bookingsCalendarCatalogViewerMapper.isMultiServiceAppointment)(bookingsSettings) || addOnsDisplay === DisplayTarget.PREFERENCES_MODAL) {
      return DisplayTarget.PREFERENCES_MODAL;
    }
    return DisplayTarget.CALENDAR;
  }
  return DisplayTarget.NONE;
};
const calculateAddOnsDisplay = (service, experiments) => {
  return (0, _bookingsCalendarCatalogViewerMapper.isServiceWithAddOns)(service, experiments) ? DisplayTarget.PREFERENCES_MODAL : DisplayTarget.NONE;
};
//# sourceMappingURL=calculatePreferencesView.js.map